<template>
    <div class="page-page">
        <slot name="navbar"></slot>

        <div class="page-content" @scroll="scroll" ref="content">
            <slot></slot>
        </div>

        <slot name="tabbar"></slot>
    </div>
</template>

<script>
    export default {
        name: 'unv-page',
        components: {},
        props: [],
        data: function () {
            return {
                scrollTop: 0,
            }
        },
        methods: {
            scroll() {
                // console.log('scroll', this.$refs.content.scrollTop);
                this.scrollTop = this.$refs.content.scrollTop;
            }
        },
        activated() {
            if (this.$refs.content) {
                // console.log('this.scrollTop', this.$refs.content, this.scrollTop);
                this.$refs.content.scrollTop = this.scrollTop;
            }
        }
    }
</script>

<style scoped>
    .page-page {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .page-content {
        flex: 1;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
    }
</style>



// WEBPACK FOOTER //
// src/components/UnvPage.vue